import { useEffect, useRef } from 'react';

import type { QuestionObjective } from 'pages/custom_tests_v1/components/question_picker/QuestionPicker';
import { useQuestionPicker } from 'pages/custom_tests_v1/components/question_picker/context';
import { Form, ListGroup } from 'react-bootstrap';

type QuestionPickerObjectiveProps = {
    objective: QuestionObjective;
};

export const QuestionPickerObjective = (props: QuestionPickerObjectiveProps) => {

    const { objective } = props;

    const { deselectAllInObjective, selectAllInObjective, selectedQuestionIds, toggleQuestion } = useQuestionPicker();

    const questionIds = objective.Questions?.map(q => q.QuestionId) ?? [];
    const selectedCount = questionIds.filter(id => selectedQuestionIds.has(id)).length;
    const allSelected = questionIds.length > 0 && selectedCount === questionIds.length;
    const someSelected = selectedCount > 0 && !allSelected;

    const objectiveCheckRef = useRef<HTMLInputElement>(null);

    useEffect(() => {

        if (objectiveCheckRef.current) {

            objectiveCheckRef.current.indeterminate = someSelected;

        }

    }, [someSelected]);

    const handleObjectiveToggle = () => {

        if (allSelected) {

            deselectAllInObjective(objective);

        } else {

            selectAllInObjective(objective);

        }

    };

    return (
        <div className="ml-3 mb-2">
            <Form.Check
                checked={allSelected}
                className="font-weight-bold small text-muted mb-1"
                id={`objective-${objective.ObjectiveId}`}
                label={objective.Name}
                onChange={handleObjectiveToggle}
                ref={objectiveCheckRef}
                type="checkbox"
            />
            <ListGroup className={'ps-3'} variant="flush">
                {objective.Questions?.map(question => (
                    <ListGroup.Item
                        action
                        className="d-flex align-items-center gap-2 py-1 px-2"
                        key={question.QuestionId}
                        onClick={() => toggleQuestion(question.QuestionId)}
                        type="button"
                    >
                        <Form.Check
                            checked={selectedQuestionIds.has(question.QuestionId)}
                            id={`question-${question.QuestionId}`}
                            onChange={() => toggleQuestion(question.QuestionId)}
                            onClick={e => e.stopPropagation()}
                            tabIndex={-1}
                            type="checkbox"
                        />
                        <span className="text-muted small" style={{ minWidth: '3.5rem' }}>
                            {question.QuestionId}
                        </span>
                        <span>
                            {question.Name}
                        </span>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        </div>
    );

};
